import { faAngleDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Button } from "react-bootstrap";
import { IConstellationInfo } from "../../../model/CarbonExternalModels";
import DeleteConstellation from "../constellation/delete/DeleteConstellation";

interface IProps {
    selectedConstellations: { [id: string]: IConstellationInfo };
    onSelectedconstellationsChange: (constellations: { [id: string]: IConstellationInfo }) => void;
}

export default function ActionsConstellations(props: IProps) {
    return (
        <>
            <Dropdown>
                <Dropdown.Toggle as={Button} className="userful-button-dropdown">
                    <p>Actions</p>
                    <FontAwesomeIcon icon={faAngleDown} />
                </Dropdown.Toggle>

                <Dropdown.Menu className="userful-icon-dropdown-menu">
                    <DeleteConstellation
                        type={"DROPDOWN"}
                        constellations={props.selectedConstellations}
                        onDelete={() => {
                            props.onSelectedconstellationsChange({});
                        }}
                    />
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
}
